
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.648 3.68H21.75V1.687a.352.352 0 00-.352-.351H.352A.352.352 0 000 1.687v15.126a.352.352 0 10.703 0V4.383h20.344v3.426a.351.351 0 10.703 0V6.727h1.547V21.96h-2.32a.352.352 0 100 .703h2.671a.352.352 0 00.352-.352V4.032a.352.352 0 00-.352-.352zm-18.398 0H.703V2.04H5.25v1.64zm15.797 0H5.953V2.04h15.094v1.64zm2.25 2.343H21.75v-1.64h1.547v1.64z","fill":"#00003C"}}),_c('path',{attrs:{"d":"M21.398 8.977a.351.351 0 00-.351.351v10.29H.703v-1.29a.352.352 0 00-.703 0v1.64c0 .195.157.352.352.352H2.25v1.992c0 .195.157.352.352.352h16.9a.351.351 0 100-.703H2.953v-1.64h18.445a.352.352 0 00.352-.352V9.329a.352.352 0 00-.352-.352z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M14.39 12.802h-7.5c-.71 0-1.288.578-1.288 1.289v.937c0 .71.578 1.29 1.289 1.29h7.5c.71 0 1.289-.58 1.289-1.29v-.937c0-.711-.579-1.29-1.29-1.29zm.587 2.226a.587.587 0 01-.586.586h-7.5a.587.587 0 01-.586-.586v-.937c0-.323.263-.586.586-.586h7.5c.323 0 .586.262.586.586v.937z","fill":"#E2E4EC"}}),_c('path',{staticClass:"active-show active-highlight",attrs:{"d":"M1.71 3.21a.352.352 0 100-.702.352.352 0 000 .703zM4.336 3.21a.352.352 0 100-.702.352.352 0 000 .703zM3.023 3.21a.352.352 0 100-.702.352.352 0 000 .703z","fill":"red"}})])
          )
        }
      }
    